import(/* webpackMode: "eager" */ "/app/src/app/diagnose/page.tsx")